var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0602 15.6153C12.629 15.1105 14.0035 14.1334 14.996 12.8178L12.2129 10.7183C11.6529 11.4607 10.8773 12.0119 9.9922 12.2968C9.10706 12.5817 8.15554 12.5862 7.26771 12.3098C6.37988 12.0335 5.59908 11.4896 5.03202 10.7527C4.46497 10.0158 4.13934 9.12168 4.09965 8.19267C4.05996 7.26367 4.30815 6.34508 4.81028 5.56246C5.31241 4.77985 6.04399 4.1714 6.90501 3.8203C7.76603 3.4692 8.71447 3.39258 9.62068 3.60091C10.5269 3.80924 11.3467 4.29235 11.9679 4.98421L14.5618 2.65503C13.4607 1.42883 12.0078 0.572599 10.4017 0.203372C8.79563 -0.165854 7.11468 -0.0300529 5.58868 0.592211C4.06267 1.21448 2.76608 2.29284 1.87613 3.67988C0.986188 5.06693 0.546324 6.69498 0.616669 8.34148C0.687013 9.98798 1.26413 11.5726 2.26914 12.8787C3.27414 14.1848 4.65799 15.1486 6.23151 15.6384C7.80503 16.1283 9.49143 16.1202 11.0602 15.6153ZM8.60938 10.3529C9.90887 10.3529 10.9623 9.29949 10.9623 8C10.9623 6.70051 9.90887 5.64706 8.60938 5.64706C7.30988 5.64706 6.25643 6.70051 6.25643 8C6.25643 9.29949 7.30988 10.3529 8.60938 10.3529Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch);
export default __webpack_public_path__ + "static/media/Clutch.b4d82336007c941b29051369648b6dc5.svg";
export { ForwardRef as ReactComponent };